export const HOMEPAGE_CALENDAR_FIRST_DAY_OF_WEEK = 2;

export function getWeeklyPageAddress(date, firstDayOfWeek = HOMEPAGE_CALENDAR_FIRST_DAY_OF_WEEK) {
  const month = date.getMonth() + 1;
  const year = date.getFullYear();
  const day = date.getDate();
  const firstWeekday = new Date(year, month - 1, 1).getDay() + 1;
  const week = Math.ceil((day + Math.abs(firstWeekday - firstDayOfWeek)) / 7);

  return { year, month, week };
}
